import React, { memo } from "react";
import { Icon } from "semantic-ui-react";
import i18nstring, { strings } from "../../i18n";
import { formatScheduleSummary } from "../../utils/PickupInstructions";

function PickupInstructionCard({
  instruction,
  instructionKey,
  dayLabels,
  isExpanded,
  onToggleExpansion,
  onEdit,
  onDelete
}) {
  const deliveryInstructionsText = instruction.deliveryInstructions || "";
  const canToggleExpansion = deliveryInstructionsText.trim().length > 110;
  const assignedZips = instruction.zips || [];

  return (
    <div className="pickup_instruction_card">
      <div className="pickup_instruction_card_content">
        <div className="pickup_instruction_detail_list">
          <div className="pickup_instruction_detail_row pickup_instruction_detail_row_with_actions">
            <div className="pickup_instruction_card_label">
              {i18nstring(strings.DELIVERY_INSTRUCTIONS)}
            </div>
            <div className="pickup_instruction_detail_main">
              <div
                className={`pickup_instruction_card_body ${!deliveryInstructionsText ? "is-empty" : ""}`}
              >
                {deliveryInstructionsText ? (
                  <div
                    className={`pickup_instruction_collapsible ${isExpanded ? "is-expanded" : ""}`}
                  >
                    <span className="pickup_instruction_collapsible_text">
                      {deliveryInstructionsText}
                    </span>
                    {canToggleExpansion && (
                      <button
                        type="button"
                        className="pickup_instruction_expand_button"
                        onClick={() => onToggleExpansion?.(instructionKey)}
                        aria-expanded={isExpanded}
                      >
                        {isExpanded
                          ? i18nstring(strings.READ_LESS)
                          : i18nstring(strings.READ_MORE)}
                      </button>
                    )}
                  </div>
                ) : (
                  "—"
                )}
              </div>
              <div className="pickup_instruction_card_actions">
                <button
                  type="button"
                  className="pickup_instruction_action_button"
                  onClick={() => onEdit?.(instruction)}
                  title={i18nstring(strings.EDIT)}
                  aria-label={i18nstring(strings.EDIT)}
                >
                  <Icon name="pencil" />
                </button>
                <button
                  type="button"
                  className="pickup_instruction_action_button pickup_instruction_action_button_delete"
                  onClick={() => onDelete?.(instruction)}
                  title={i18nstring(strings.DELETE)}
                  aria-label={i18nstring(strings.DELETE)}
                >
                  <Icon name="trash alternate outline" />
                </button>
              </div>
            </div>
          </div>

          <div className="pickup_instruction_detail_row">
            <div className="pickup_instruction_card_label">
              {i18nstring(strings.ADD_EDIT_SCHEDULES)}
            </div>
            <div className="pickup_instruction_card_body">
              {formatScheduleSummary(instruction.deliverySchedule, dayLabels)}
            </div>
          </div>

          <div className="pickup_instruction_detail_row pickup_instruction_detail_row_zips">
            <div className="pickup_instruction_card_label">
              {i18nstring(strings.ZIPS_LABEL)}
            </div>
            <div className="pickup_instruction_tags">
              {assignedZips.length > 0 ? (
                assignedZips.map(zip => (
                  <span
                    key={`${instruction.id || "draft"}-${zip}`}
                    className="pickup_instruction_tag"
                  >
                    {zip}
                  </span>
                ))
              ) : (
                <span className="pickup_instruction_tag pickup_instruction_tag_empty">
                  {i18nstring(strings.NO_ZIPS_ASSIGNED)}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(PickupInstructionCard);
